import {Mapper} from '@s-ui/domain'

export default class FromModelsHttpRepositoryDataToModelsValueObjectMapper extends Mapper {
  constructor({config, modelEntityFactory, toCapitalCase}) {
    super()
    this._config = config
    this._modelEntityFactory = modelEntityFactory
    this._toCapitalCase = toCapitalCase
  }

  // It may replace blank spaces, hyphens and underscores and capitalize resulting words
  _capitalizeName = name =>
    name
      .split(' ')
      .map(this._toCapitalCase)
      .join(' ')
      .split('-')
      .map(this._toCapitalCase)
      .join('-')
      .split('_')
      .map(this._toCapitalCase)
      .join(' ')

  map = ({model: {model, imageUrlPath, urlPath, bodyType, doors}, makeUrlParam}) => {
    const URL_VEHICLES_IMAGES = this._config.get('URL_VEHICLES_IMAGES')
    const image = imageUrlPath ? `${URL_VEHICLES_IMAGES}${imageUrlPath}` : ''
    const modelName = model && this._capitalizeName(model)
    const makeName = makeUrlParam && this._capitalizeName(makeUrlParam)

    const modelData = {
      name: modelName,
      image,
      url: urlPath,
      bodyType,
      doors,
      make: makeName
    }

    return this._modelEntityFactory({...modelData})
  }
}
